import type { Mode } from "../../../components/general/types/Modify";
import { api } from "../../../services/jobpermissions.service";
import { useJobPermission } from "./useJobPermission";

const permission = "GenerateDocumentForAnyJob";

export const useCanGenerateDocument = (mode: Mode, fetch: boolean) =>
  useJobPermission(mode, fetch, api.generateDocument, permission);
